<app-loader *ngIf="isDisabled || isPageDisabled"></app-loader>
<div class="card">
    <form class="g-3" name="ApprovalMatrixForm" (ngSubmit)="Validate(ApprovalMatrixForm)" #ApprovalMatrixForm="ngForm"
        novalidate>
        <div class="card-body p-0">
            <div class="card mb-1">
                <div class="card-header">
                    Approval Matrix
                </div>
                <div class="card-body">
                    <div class="row pb-2">
                        <div class="col-md-4">
                            <label for="WorkFlowName" class="form-font-label">Work Flow Name<span
                                    class="text-danger">*</span></label>
                            <input type="text" maxlength="100" class="form-control" placeholder="Ex. Attendace Approval"
                                id="WorkFlowName" name="WorkFlowName" [(ngModel)]="ApprovalMatrixDetail.WorkFlowName"
                                #WorkFlowName="ngModel" required>
                            <div class="invalid-feedback">
                                Please enter work flow name!
                            </div>
                        </div>
                        <div class="col-md-4">
                            <label for="WebESSModuleMasterId" class="form-font-label">Module<span
                                    class="text-danger">*</span></label>
                            <ng-select name="WebESSModuleMasterId" (change)="DefaultTATSet()"
                                [(ngModel)]="ApprovalMatrixDetail.WebESSModuleMasterId" #WebESSModuleMasterId="ngModel"
                                placeholder="--Select Module--"
                                [disabled]="ApprovalMatrixDetail.WebESSApprovalMatrixId > 0" required>
                                <ng-option *ngFor="let Module of Modules"
                                    [value]="Module.WebESSModuleMasterID">{{Module.ModuleName}}</ng-option>
                            </ng-select>

                            <div class="invalid-feedback">
                                Please select module!
                            </div>
                        </div>
                    </div>
                    <div class="row pb-2" *ngIf="Filter.IsAllowMaxAgeLimit">
                        <div class="col-md-2">
                            <label for="DefaultRule" class="form-label text-label-dark">Max Age Limit:</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]='true' name="IsMaxAgeLimit"
                                        [(ngModel)]="ApprovalMatrixDetail.IsMaxAgeLimit"
                                        [ngModelOptions]="{standalone: true}" [disabled]="!Filter.IsAllowMaxAgeLimit"
                                        required>
                                    Yes
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]='false' name="IsMaxAgeLimit"
                                        [(ngModel)]="ApprovalMatrixDetail.IsMaxAgeLimit"
                                        [ngModelOptions]="{standalone: true}" [disabled]="!Filter.IsAllowMaxAgeLimit"
                                        required>
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row pb-2" *ngIf="Filter.IsAllowTravelType">
                        <div class="col-md-2">
                            <label for="TravelType" class="form-label text-label-dark">Travel Type:</label>
                        </div>
                        <div class="col-md-5">
                            @for (TravelType of common.TravelTypes; track TravelType.TravelType; let i = $index)
                            {
                            <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                <input class="form-check-input" type="radio" [value]=TravelType.Value name='TravelType'
                                    [(ngModel)]="ApprovalMatrixDetail.TravelType" [ngModelOptions]="{standalone: true}">
                                {{TravelType.TravelType}}
                            </label>
                            }
                        </div>
                    </div>
                    <div class="row pb-2">
                        <div class="col-md-2">
                            <label for="DefaultRule" class="form-label text-label-dark">Employee Type:</label>
                        </div>
                        <div class="col-md-5">
                            <div class="btn-group btn-group-toggle">
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                    *ngIf="(this.ApprovalMatrixDetail.WebESSApprovalMatrixId == 0) || (this.ApprovalMatrixDetail.WebESSApprovalMatrixId > 0 && common.ToLowerCase(ApprovalMatrixDetail.EmpType) == 'front')">
                                    <input class="form-check-input" type="radio" value='FRONT' name="EmpType"
                                        [(ngModel)]="ApprovalMatrixDetail.EmpType" [ngModelOptions]="{standalone: true}"
                                        (change)="GetApplicability()"
                                        [disabled]="ApprovalMatrixDetail.WebESSApprovalMatrixId > 0" required>
                                    Front Office
                                </label>
                                <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel
                                    *ngIf="(this.ApprovalMatrixDetail.WebESSApprovalMatrixId == 0) || (this.ApprovalMatrixDetail.WebESSApprovalMatrixId > 0 && common.ToLowerCase(ApprovalMatrixDetail.EmpType) == 'back')">
                                    <input class="form-check-input" type="radio" value='BACK' name="EmpType"
                                        [(ngModel)]="ApprovalMatrixDetail.EmpType" [ngModelOptions]="{standalone: true}"
                                        (change)="GetApplicability()"
                                        [disabled]="ApprovalMatrixDetail.WebESSApprovalMatrixId > 0" required>
                                    Back Office
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mb-1">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Approval</div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                                (click)="AddApproval()"><i class="bi bi-plus" *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Add Approval':'Loading...'}}</button>
                        </div>
                    </div>
                </div>

                @for (Approvel of ApprovalMatrixDetail.ESS_ApprovalMatrixDetails; track Approvel.ApprovalLevel;
                let i = $index) {
                <div class="card">
                    <div class="card-body">
                        <h6 class="card-subtitle mb-2 text-muted">
                            <div class="row">
                                <div class="col">Approval - {{i + 1}}</div>
                                <div class="col-auto">
                                    <i class="bi bi-x-circle text-danger" (click)="DeleteApproval(i)"
                                        *ngIf="!isDisabled"></i>
                                </div>
                            </div>

                        </h6>
                        <div class="row pb-2">
                            <div class="col-md-3">
                                <label for="ApprovalCategoryId" class="form-font-label">Approval Type<span
                                        class="text-danger">*</span></label>
                                <ng-select name="ApprovalCategoryId{{i}}" [(ngModel)]="Approvel.ApprovalCategoryId"
                                    #ApprovalCategoryId="ngModel" (change)='ApprovalTypeChange(i,true)'
                                    placeholder="--Select Approval Type--" required>
                                    <ng-option *ngFor="let ApprovalCategory of ApprovalCategorys"
                                        [value]="ApprovalCategory.WebESSApprovalCategoryMasterID">{{ApprovalCategory.ApprovalCategoryName}}</ng-option>
                                </ng-select>
                                <div class="invalid-feedback">
                                    Please select approval type!
                                </div>
                            </div>

                            <div class="col-md-3" *ngIf="Approvel.ViewSubCategory">
                                <label for="ApprovalCategoryVal" class="form-font-label">Sub Category<span
                                        class="text-danger">*</span></label>

                                <ng-select name="ApprovalCategoryVal{{i}}" [(ngModel)]="Approvel.ApprovalCategoryVal"
                                    #ApprovalCategoryVal="ngModel" placeholder="--Select Sub Category--" required>
                                    <ng-option *ngFor="let ApprovalSubCategory of ApprovalSubCategoryFilter[i]"
                                        [value]="ApprovalSubCategory.ApprovalSubCategoryID">{{ApprovalSubCategory.ApprovalSubCategory}}</ng-option>
                                </ng-select>
                                <div class="invalid-feedback">
                                    Please select sub category!
                                </div>
                            </div>

                            <div class="col-md-3">
                                <label for="TAT_INDays" class="form-font-label">TAT<span
                                        class="text-danger">*</span></label>
                                <input type="text" maxlength="3" pattern="^[0-9]\d*$"
                                    (keypress)="common.NumberOnly($event)"
                                    [ngClass]="{'ng-invalid': common.parseFloat(Approvel.TAT_INDays) > 365}"
                                    class="form-control" placeholder="Ex. 1" id="TAT_INDays" name="TAT_INDays{{i}}"
                                    [(ngModel)]="Approvel.TAT_INDays" #TAT_INDays="ngModel" required>
                                <div class="invalid-feedback">
                                    Please enter work tat maximum 365!
                                </div>
                            </div>
                            <div class="col-md-3">
                                <!-- <label for="IsAutoRejection{{i}}" class="form-font-label">Approve Reject Before TAT<span
                                        class="text-danger">*</span></label> -->
                                <div class="btn-group btn-group-toggle text-center pt-4 mt-2">
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]='false'
                                            name="IsAutoRejection{{i}}" [(ngModel)]="Approvel.IsAutoRejection"
                                            [ngModelOptions]="{standalone: true}" required>
                                        Auto Approve
                                    </label>
                                    <label class="form-check-label link-dark px-1 text-label-light" ngbButtonLabel>
                                        <input class="form-check-input" type="radio" [value]='true'
                                            name="IsAutoRejection{{i}}" [(ngModel)]="Approvel.IsAutoRejection"
                                            [ngModelOptions]="{standalone: true}" required>
                                        Auto Reject
                                    </label>
                                </div>
                                <div class="invalid-feedback">
                                    Please select approve reject before TAT!
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>

            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col">Applicability</div>
                        <div class="col-md-3">
                            <div class="input-group">
                                <div class="input-group-text"><i class="bi bi-search"></i></div>
                                <input type="text" class="form-control" placeholder="Search Here.."
                                    (keyup)="SearchDropdown($any($event.target).value,'Applicability')">
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
                                (click)="ButtonApplicabilityDataFilter()"><i class="bi bi-funnel"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Filter':'Loading...'}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="btn-group btn-group-toggle d-flex flex-column bg-light">
                                @for (Applicability of Applicabilitys; track Applicability.WebESSApplicabilityMasterID;
                                let i = $index) {
                                <label class="form-check-label text-label-dark px-1" ngbButtonLabel>
                                    <input class="form-check-input" type="radio"
                                        [value]=Applicability.WebESSApplicabilityMasterID
                                        name='WebESSApplicabilityMasterID'
                                        [(ngModel)]="ApprovalMatrixDetail.WebESSApplicabilityId"
                                        [ngModelOptions]="{standalone: true}" (change)="ApplicabilityDataFilter()">
                                    {{Applicability.ApplicabilityName}}

                                    <i *ngIf="Applicability.WebESSApplicabilityMasterID == 3 || Applicability.WebESSApplicabilityMasterID == 4 || Applicability.WebESSApplicabilityMasterID == 8"
                                        class="bi bi-funnel"></i>
                                </label>
                                }
                            </div>
                        </div>
                        <div class="col-md-10">
                            <div class="row">
                                <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                    <input class="form-check-input" type="checkbox" value="" id="SelectAll"
                                        (change)="ApplicabilityCheckAll($event)">
                                    <label for="SelectAll">
                                        Select All
                                    </label>
                                </div>
                            </div>
                            <div class="row">
                                <label
                                    *ngIf="ApplicabilityDatas.length == 0 && ApprovalMatrixDetail.WebESSApplicabilityId > 0">Please
                                    select filter</label>
                                @for (ApplicabilityData of OrderByApplicability(); track
                                ApplicabilityData.ApplicabilityDataID;
                                let i = $index) {
                                <div class="col-md-4">
                                    <div class="form-check" *ngIf="ApplicabilityDatas.length > 0">
                                        <input class="form-check-input" type="checkbox"
                                            id="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            name="ChkOut{{ApplicabilityData.ApplicabilityDataID}}"
                                            [(ngModel)]="ApplicabilityData.IsCheck">
                                        <label class="form-check-label applicability-font"
                                            for="ChkOut{{ApplicabilityData.ApplicabilityDataID}}">
                                            {{ApplicabilityData.ApplicabilityData}}
                                        </label>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <div *ngIf="(this.common.PageRight.IsAdd && this.ApprovalMatrixDetail.WebESSApprovalMatrixId == 0) || (this.common.PageRight.IsEdit && this.ApprovalMatrixDetail.WebESSApprovalMatrixId > 0)"
                    class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-save2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </form>
</div>